import { Paper, Typography, TextField } from 'material-ui';
import { withStyles } from 'material-ui/styles/index'; // only needs to be imported once
import React from 'react';
import { translate } from 'react-i18next';
import { Grid } from 'material-ui';


const styles = theme => ({
    clientRowTitle: {
        fontSize: '14px',
        fontWeight: 600,
        paddingLeft: '20px !important',
    },
    clientRowValue: {
        fontSize: '14px',
        fontWeight: 300,
        paddingLeft: '20px'
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    bookingSubtitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 5px 25px',
        fontWeight: 'normal',
        fontSize: '1rem'
    },
    paperFrame: {
        margin: '40px 0px'
    },
    mainGrid: {
        padding: '20px'
    }
});


class TinyFlightRender extends React.Component {
    constructor(props) {
        super(props);
        let ds = this.getDefaultState();
        if (props.flightinformation) {
            ds.flightinformation = props.flightinformation;
        }
        this.state = ds;
    }

    getDefaultState = () => {
        return {
            flightinformation: {
                airport: '',
                forth: { flightNumber: '' },
                back: { flightNumber: '' }
            },
            arpError: false,
            fromError: false,
            toError: false,
            isValid: true
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.flightinformation) {
            this.setFlightData({ flightinformation: nextProps.flightinformation });
        }
    }

    componentDidMount() {
        //super.componentDidMount();
        this.validateElement(this.state);
    }

    validateElement = (data) => {
        data.fromError = this.props.requiredItems >= 1 && !(data.flightinformation && data.flightinformation.forth && String(data.flightinformation.forth.flightNumber) !== '');
        data.toError = this.props.requiredItems >= 2 && !(data.flightinformation && data.flightinformation.back && String(data.flightinformation.back.flightNumber) !== '');
        data.isValid = !data.fromError && !data.toError;
        return data;
    }

    setFlightData = (data) => {
        data = this.validateElement(data);
        this.setState(data);
    }

    render() {
        const { type, classes, t, required, requiredItems, viewOnlyMode } = this.props;

        let auxTitle = '';
        if (type) {
            auxTitle = ' de ' + t(`TRANSFERS.${type}`);
        }

        return (
            <Paper className={classes.paperFrame}>
                <Typography className={classes.bookingTitle}>
                    {t('BOOKING_DETAIL.FLIGHT_DETAIL') + auxTitle}
                </Typography>
                <Grid container className={classes.mainGrid + ' formContainer cmsFlightInfo'}>
                    <Grid item>
                        {viewOnlyMode ?
                            <TextField label={t('BO.flightinformation.airport')}
                                value={this.state.flightinformation.airport ? this.state.flightinformation.airport : ''} />
                            :
                            <TextField
                                label={t('BO.flightinformation.airport')}
                                required={(required !== undefined ? required : true) && !viewOnlyMode}
                                error={this.state.arpError}
                                value={this.state.flightinformation.airport}
                                onBlur={e => {
                                    if (this.props.onBlur) {
                                        this.props.onBlur(e);
                                    }
                                }}
                                onChange={e => {
                                    if (viewOnlyMode) return;
                                    let sta = this.state;
                                    sta.flightinformation.airport = String(e.target.value);
                                    sta.arpError = required && String(e.target.value) === '';
                                    // console.log(sta);
                                    this.setFlightData(sta);
                                }}>
                            </TextField>
                        }
                    </Grid>
                    <Grid item>
                        <TextField
                            label={'N° ' + t('BOOKING_DETAIL.OUTBOUND_FLIGHT')}
                            required={requiredItems >= 1 && !viewOnlyMode}
                            error={this.state.fromError}
                            value={this.state.flightinformation && this.state.flightinformation.forth && this.state.flightinformation.forth.flightNumber}
                            onBlur={e => {
                                if (this.props.onBlur) {
                                    this.props.onBlur(e);
                                }
                            }}
                            onChange={e => {
                                if (viewOnlyMode) return;
                                let sta = this.state;
                                sta.flightinformation.forth.flightNumber = String(e.target.value).toUpperCase();
                                // console.log(sta);
                                this.setFlightData(sta);
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.disabledTextFieldInput
                                }
                            }}
                            inputProps={{
                                maxLength: 6
                            }}>
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField
                            label={'N° ' + t('BOOKING_DETAIL.RETURN_FLIGHT')}
                            value={this.state.flightinformation && this.state.flightinformation.back ? this.state.flightinformation.back.flightNumber : this.state.flightinformation.back.flightNumber}
                            required={requiredItems >= 2 && !viewOnlyMode}
                            disabled={requiredItems < 2}
                            error={this.state.toError}
                            onBlur={e => {
                                if (this.props.onBlur) {
                                    this.props.onBlur(e);
                                }
                            }}
                            onChange={e => {
                                if (viewOnlyMode) return;
                                let sta = this.state;
                                sta.flightinformation.back.flightNumber = String(e.target.value).toUpperCase();
                                this.setFlightData(sta);
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.disabledTextFieldInput
                                }
                            }}
                            inputProps={{
                                maxLength: 6
                            }}>
                        </TextField>
                    </Grid>
                </Grid>
            </Paper >
        );
    }
}
export default translate('translations')(withStyles(styles)(TinyFlightRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/Flight/TinyFlightRender.js